import React from 'react';
import propTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import useLearningJourneys from '@helpers/hooks/use-learning-journeys';
import PortalCommunication from '@helpers/portal-comms';
import { getConfiguration } from '@helpers/utils';
import { VideoHelp, Collapse, Expand } from '@helpers/icon-dictionary';
import css from './grid-actions.scss';
import { toggleStandardCollapse } from '../standards';

function GridActions({ i18n }) {
  const learningJourneyIds = useLearningJourneys();
  const girlIds = getConfiguration('girlIdsForInfoModal') || [];
  const invokeInfoModal = () => {
    PortalCommunication.requestInfoModal(girlIds);
  };

  return (
    <React.Fragment>
      <div className={css.buttonsContainer}>
        {
          girlIds.length === 0 ? null : <Button
            alignIcon="LEFT"
            className={css.howThisWorks}
            onClick={invokeInfoModal}
            icon={VideoHelp}
            text={i18n.t`How this works`}
            primary
            type={Button.LOZENGE} />
        }
        <div className={css.bottomButtons}>
          <Button
            alignIcon="LEFT"
            className={css.key}
            disabled={!learningJourneyIds.length}
            icon={Expand}
            onClick={() => toggleStandardCollapse(false)}
            primary
            text={i18n.t`Expand All`}
            type={Button.LOZENGE} />
          <Button
            alignIcon="LEFT"
            className={css.key}
            disabled={!learningJourneyIds.length}
            icon={Collapse}
            onClick={() => toggleStandardCollapse(true)}
            primary
            text={i18n.t`Collapse All`}
            type={Button.LOZENGE} />
        </div>
      </div>
    </React.Fragment>
  );
}

GridActions.propTypes = {
  i18n: propTypes.object
};

export default GridActions;



// WEBPACK FOOTER //
// ./components/grid-actions/index.js